export default __webpack_public_path__ + "static/media/Sunny.e11f7275.mp4";